import React from 'react';
import { Input, InputProps } from '@heroui/react';
import Typography from './typography/Typography';
import { InfoCircle } from './icons';

interface CustomHeroInputProps extends Omit<InputProps, 'classNames'> {
  label: string;
  required?: boolean;
  error?: string;
  touched?: boolean;
  infoIconText?: string;
  className?: string;
  description?: string;
}

const CustomHeroInput: React.FC<CustomHeroInputProps> = ({
  label,
  required = false,
  error,
  touched,
  infoIconText,
  className = '',
  description,
  disabled,
  ...inputProps
}) => {
  const isPartner = window.location.pathname.startsWith('/partner');
  return (
    <div className={`flex flex-col ${className}`}>
      <div className="flex items-center gap-[4px] mb-[8px]">
        {label && (
          <Typography variant="body2" className={error && touched ? 'text-[#F31260]' : disabled ? 'text-[#A1A1AA]' : 'text-[#11181c]'}>
            {label}
            {required && <span className={error && touched ? 'text-[#F31260]' : `${isPartner ? 'text-[#006fee]' : 'text-[#9675CE]'}`}>*</span>}
          </Typography>
        )}
        {infoIconText && <InfoCircle/>}
      </div>
      <Input
        {...inputProps}
        disabled={disabled}
        variant="bordered"
        className="w-full h-[38px]"
        classNames={{
          inputWrapper: `border-[#D4D4D8] max-h-[38px] min-h-[38px] rounded-lg h-10 ${
            error && touched ? 'border-[#F31260]' : ''
          } ${disabled ? 'bg-[#F4F4F5] opacity-60' : ''}`,
          input: disabled ? 'text-[#71717A]' : '',
        }}
      />
      {description && (
        <Typography variant='body2' className="text-[#71717A] text-[9px] leading-[14px] mt-[4px]">{description}</Typography>
      )}
      {error && touched && (
        <Typography variant='body2' className={`text-[#F31260] text-xs`}>{error}</Typography>
      )}
    </div>
  );
};

export default CustomHeroInput;
